import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PasswordGeneratorService {

  constructor() { }

  generatePassword(): string {
    let password = '';

    let digitsCounter = 0;
    let lettersCounter = 0;
    let upperCaseCounter = 0;
    let lowerCaseCounter = 0;

    for (let i = 0; i < 8; i++) {

      const digit: boolean = ((Math.floor(Math.random() * 100) % 2 == 1) && digitsCounter < 3) || lettersCounter > 4;

      if (digit) {
        digitsCounter++;
        password += this.randomDigit();
      } else {
        const upperCase: boolean = ((Math.floor(Math.random() * 100) % 2 == 1) && upperCaseCounter < 3) || lowerCaseCounter > 2;
        lettersCounter++;
        if (upperCase) {
          upperCaseCounter++;
          password += this.randomLetterUpperCase();
        } else {
          lowerCaseCounter++;
          password += this.randomLetterLowerCase();
        }
      }

    }

    console.log(digitsCounter, lowerCaseCounter, upperCaseCounter);

    return password;

  }


  private randomLetterLowerCase(): string {

    const lowerCaseCode: number = Math.floor(Math.random() * (122 + 1 - 97) + 97);

    const letter: string = String.fromCharCode(lowerCaseCode);

    return letter;
  }

  private randomLetterUpperCase(): string {

    const upperCaseCode: number = Math.floor(Math.random() * (90 + 1 - 65) + 65);

    const letter: string = String.fromCharCode(upperCaseCode);

    return letter;
  }

  private randomDigit(): string {

    const n: number = Math.floor(Math.random() * 10);

    return n.toString();

  }

}
